module.exports = __webpack_public_path__ + "static/media/Huis-1-1.560ade1d.jpg";